import React, { Component } from 'react';

class Header extends Component {
    render() {    
        return (
            <section className={'header ' + (this.props.whitelabel ? 'white-label' : '')}>
                <div className="container clearfix">     
                    { !this.props.whitelabel ? 
                        <div className="logo" />
                    : null }
                    <h1>Target-Date Blueprint</h1>  
                    {this.props.children}
                </div>
            </section>
        );
    }
}

export default Header;
